import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';
import { runOptimisticCachedQueryPatches } from './queryCacheUtils';

export const categoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: (args = {}) => ({
        url: '/api/categories',
        params: buildListQueryParams(args),
      }),
      providesTags: ['Categories'],
    }),
    getCategoryById: builder.query({
      query: (id) => `/api/categories/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Categories', id }],
    }),
    createCategory: builder.mutation({
      query: ({
        name,
        status = true,
        category_complain_type,
        vendor_id,
        accountable_department_id,
      }) => ({
        url: '/api/categories',
        method: 'POST',
        body: {
          name,
          status,
          category_complain_type,
          vendor_id,
          accountable_department_id,
        },
      }),
      invalidatesTags: ['Categories'],
    }),
    updateCategory: builder.mutation({
      query: ({
        id,
        name,
        category_complain_type,
        vendor_id,
        accountable_department_id,
      }) => ({
        url: `/api/categories/${id}`,
        method: 'PUT',
        body: {
          category: {
            name,
            category_complain_type,
            vendor_id,
            accountable_department_id,
          },
        },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        'Categories',
        { type: 'Categories', id },
      ],
    }),
    updateCategoryStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/api/categories/${id}/update_status`,
        method: 'PATCH',
        body: { status },
      }),
      // Do not invalidate/refetch here — backend often returns a new sort order and the row jumps.
      async onQueryStarted({ id, status }, { dispatch, getState, queryFulfilled }) {
        await runOptimisticCachedQueryPatches({
          dispatch,
          getState,
          queryFulfilled,
          endpointName: 'getCategories',
          updateDraft: (draft) => {
            const list = draft?.data;
            if (!Array.isArray(list)) return;
            const row = list.find((c) => Number(c.id) === Number(id));
            if (row) row.status = status;
          },
        });
      },
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useLazyGetCategoryByIdQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useUpdateCategoryStatusMutation,
} = categoryApi;

